exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton[data-v-aaabb176] {\n  white-space: nowrap;\n}\n.btn-filter-followup[data-v-aaabb176] {\n    border: 0px;\n    font-size: 1em;\n    color: #444;\n    padding: 0;\n    line-height: 2.7em !important;\n    background: transparent !important;\n}\n.btn-filter-followup[data-v-aaabb176]:hover {\n    color: #444 !important;\n    background: transparent !important;\n}\n", ""]);

// exports
